import type {
  landingPageGroup,
  marketingSource,
  DataMining,
} from '../entities/DataMining'

export const setDataMiningOnSessionStorage = () => {
  const route = useRoute()

  const matchRoute = (route: string): number | undefined => {
    const sources: { [key: number]: string[] } = {
      2: ['casas-rurales'],
      3: ['casa-rural'],
      4: [''],
      5: ['ofertas-casas-rurales', 'oferta'],
      6: ['blog'],
      7: ['guias-de-viaje', 'que-hacer'],
    }

    const routeParts = route.split('/')
    const firstPart = routeParts[1]

    for (const number in sources) {
      if (sources[number].includes(firstPart)) {
        return parseInt(number)
      }
    }
    return 1
  }

  const getUrlParam = (param: string) => {
    const urlParam = route.query[param]
    return urlParam
  }

  const getSource = () => {
    const ref = document.referrer
    const mailingPatt = getUrlParam('utm_source')
    const semPatt = getUrlParam('gclid')
    const googlePatt = /google/
    const socialPatt = /facebook|t|instagram|youtube/
    if (mailingPatt === 'emailmkt') {
      return 'MAILING'
    }
    if (semPatt) {
      return 'SEM'
    }
    if (!ref) {
      return 'DIRECT'
    }
    if (googlePatt.test(ref)) {
      return 'SEO'
    }
    if (socialPatt.test(ref)) {
      return 'SOCIAL'
    }
    return 'REFERER'
  }

  try {
    if (sessionStorage.getItem('cc_category') === null) {
      const cc_route = matchRoute(route.path)
      sessionStorage.setItem('cc_category', `${cc_route}`)
    }

    if (sessionStorage.getItem('conversion_source') === null) {
      const source = getSource()
      sessionStorage.setItem('conversion_source', source)

      if (source === 'MAILING') {
        const utm = getUrlParam('utm_campaign')
        if (utm) {
          sessionStorage.setItem('conversion_utm', `${utm}`)
        }
      }
    }
  } catch (error) {
    console.error('Session Storage error:', error)
  }
}

export const getDataMining = (): DataMining => {
  const { isMobile } = useDevice()
  const platform = isMobile ? 'web_mobile' : 'web_desktop'
  const landingPageGroup = sessionStorage.getItem(
    'cc_category',
  ) as landingPageGroup
  const marketingSource = sessionStorage.getItem(
    'conversion_source',
  ) as marketingSource
  const campaignUTM = sessionStorage.getItem('conversion_utm')

  return {
    platform,
    landingPageGroup,
    marketingSource,
    campaignUTM,
  }
}
